export const TEAM_MEMBERS = ["David", "Minsun", "Rezky", "Xiaohang", "Susan"];

export const BEHAVIOR_CODES = [
  { id: 'flow', label: 'Flow / Productive', color: '#4caf50', desc: "Steady progress with successful runs." },
  { id: 'strategic', label: 'Strategic Verification', color: '#2196f3', desc: "Thoughtful pausing to check logic/logs." },
  { id: 'death_spiral', label: 'The Death Spiral', color: '#d32f2f', desc: "Rapid high-freq error loops without reflection." },
  { id: 'paralysis', label: 'Cognitive Paralysis', color: '#7b1fa2', desc: "Frozen (>60s) after error. No typing/scrolling." },
  { id: 'thrashing', label: 'Silent Thrashing', color: '#ff9800', desc: "Resubmitting identical code repeatedly." },
  { id: 'blind', label: 'Blind Integration', color: '#f44336', desc: "Copy-pasting AI code without reading." },
  { id: 'mismatch', label: 'Scaffolding Mismatch', color: '#607d8b', desc: "Asking for examples but getting vague hints." }
];

export const TABLE_COLUMNS = [
  { id: 'student', label: 'Student', sortable: true },
  { id: 'topic', label: 'Topic', sortable: true },
  { id: 'status', label: 'Status', sortable: true },
  { id: 'review', label: 'Review', sortable: false },
  { id: 'actions', label: 'Actions', align: 'center', sortable: false },
];